import React from 'react';
import ReactApexCharts from 'react-apexcharts';
import PropTypes from 'prop-types';
import { formatNumber } from 'helper';

function PieChart({ data, isLoading }) {
  const options = {
    chart: {
      type: 'pie',
    },
    labels: data?.map((x) => x?.mask_name),
    dataLabels: {
      formatter: (val) => `${Math.round(val * 10) / 10}%`,
    },
    colors: [
      '#003554',
      '#F88125',
      '#FAAB6D',
      '#FBD016',
      '#FED766',
      '#006494',
      '#0582CA',
      '#00B4CC',
      '#FE4A49',
    ],
    legend: {
      position: 'bottom',
      horizontalAlign: 'left',
      itemMargin: {
        horizontal: 0,
        vertical: 2,
      },
    },
    tooltip: {
      y: {
        formatter(val) {
          if (!val) return '';
          return formatNumber(val, 0);
        },
      },
    },
  };

  const series = data?.map((x) => x?.count);

  if (isLoading) {
    return (
      <div className="h-full w-full pl-10 py-8 pr-6">
        <div
          className="animate-pulse bg-gray-50 h-full w-full rounded"
          style={{
            clipPath:
              'polygon(0 80%, 13% 71%, 25% 55%, 39% 44%, 54% 51%, 66% 46%, 78% 34%, 90% 22%, 100% 33%, 100% 43%, 100% 100%, 0% 100%)',
          }}
        />
      </div>
    );
  }
  return (
    <ReactApexCharts
      height="100%"
      options={options}
      series={series}
      type="pie"
    />
  );
}
PieChart.defaultProps = {
  data: [],
  isLoading: false,
};

PieChart.propTypes = {
  data: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool,
};

export default PieChart;
